import { render, staticRenderFns } from "./mobileShield.vue?vue&type=template&id=54e6b30a&scoped=true"
import script from "./mobileShield.vue?vue&type=script&lang=js"
export * from "./mobileShield.vue?vue&type=script&lang=js"
import style0 from "./mobileShield.vue?vue&type=style&index=0&id=54e6b30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6b30a",
  null
  
)

export default component.exports